import hash from "utils/hash";
import { SpeciesEnum } from "../../../../__generated__/globalTypes";
import { getOrg } from "utils/site";
import { getLimits } from "./constants";
import {
  AddrevenueIdEnumFra,
  AddrevenueIdEnumGer,
  AdtractionIdEnumGer,
  FinanceAdsCategoryEnumGer,
  financeAdsCookie,
} from "utils/ad-network";
import { limitsEnum } from "../config/ger/plans";
import { getCookie } from "utils/cookie";
import { CheckMultiBind_checkMultiBind } from "../../../../__generated__/CheckMultiBind";

export const getMarketingProps = (
  policy: CheckMultiBind_checkMultiBind["policy"],
  species: SpeciesEnum
) => {
  if (!policy) return {};

  const adtractionMd5 = hash.md5(policy.client?.email ?? "");

  const org = getOrg();

  switch (org) {
    case "fra": {
      if (getLimits().includes(policy.limit)) {
        return species === SpeciesEnum.cat
          ? {
              adtractionId: undefined,
              adtractionMd5,
              addrevenueId: AddrevenueIdEnumFra.HealthCat,
              financeAdsCategory: undefined,
              financeAdsSid: undefined,
            }
          : {
              adtractionId: undefined,
              adtractionMd5,
              addrevenueId: AddrevenueIdEnumFra.HealthDog,
              financeAdsCategory: undefined,
              financeAdsSid: undefined,
            };
      }

      return {
        adtractionId: undefined,
        adtractionMd5,
        addrevenueId: undefined,
        financeAdsCategory: undefined,
        financeAdsSid: undefined,
      };
    }
    case "ger": {
      if (policy.limit === limitsEnum.OP) {
        return species === SpeciesEnum.cat
          ? {
              adtractionId: AdtractionIdEnumGer.OpCat,
              adtractionMd5,
              addrevenueId: AddrevenueIdEnumGer.OpCat,
              financeAdsCategory: FinanceAdsCategoryEnumGer.OpCat,
              financeAdsSid: getCookie(financeAdsCookie.name) ?? "",
            }
          : {
              adtractionId: AdtractionIdEnumGer.OpDog,
              adtractionMd5,
              addrevenueId: AddrevenueIdEnumGer.OpDog,
              financeAdsCategory: FinanceAdsCategoryEnumGer.OpDog,
              financeAdsSid: getCookie(financeAdsCookie.name) ?? "",
            };
      }

      if (
        [limitsEnum.Mini, limitsEnum.Midi, limitsEnum.Maxi].includes(
          policy.limit
        )
      ) {
        return species === SpeciesEnum.cat
          ? {
              adtractionId: AdtractionIdEnumGer.HealthCat,
              adtractionMd5,
              addrevenueId: AddrevenueIdEnumGer.HealthCat,
              financeAdsCategory: FinanceAdsCategoryEnumGer.HealthCat,
              financeAdsSid: getCookie(financeAdsCookie.name) ?? "",
            }
          : {
              adtractionId: AdtractionIdEnumGer.HealthDog,
              adtractionMd5,
              addrevenueId: AddrevenueIdEnumGer.HealthDog,
              financeAdsCategory: FinanceAdsCategoryEnumGer.HealthDog,
              financeAdsSid: getCookie(financeAdsCookie.name) ?? "",
            };
      }

      return {
        adtractionId: AdtractionIdEnumGer.Liability,
        adtractionMd5,
        addrevenueId: AddrevenueIdEnumGer.Liability,
        financeAdsCategory: FinanceAdsCategoryEnumGer.Liability,
        financeAdsSid: getCookie(financeAdsCookie.name) ?? "",
      };
    }

    default:
      break;
  }
};
